import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useRef, useContext, useEffect, useMemo, useState } from 'react';
import { L as Label, a as LabelTypography, b as LabelColors } from '../../index-6420013c.js';
import Icon, { IconTypes, IconColors } from '../../ui/Icon.js';
import Avatar from '../../ui/Avatar.js';
import { a as LocalizationContext } from '../../LocalizationContext-a82461b5.js';
import { u as uuidv4 } from '../../uuid-717930b4.js';
import { u as useChannelContext } from '../../ChannelProvider-5dcbee7b.js';
import useSendbirdStateContext from '../../useSendbirdStateContext.js';
import { U as USER_MENTION_TEMP_CHAR, M as MAX_USER_MENTION_COUNT, a as MAX_USER_SUGGESTION_COUNT } from '../../const-72f012b6.js';
import { M as MessageInputKeys } from '../../const-3a34a127.js';
import { u as useThreadContext } from '../../ThreadProvider-cf357120.js';
import 'prop-types';
import '../../stringSet-b60e9529.js';
import '../../ui/ImageRenderer.js';
import '../../index-6add7940.js';
import '../../UserProfileContext-f3f446d2.js';
import '../../index-ccef08fe.js';
import '../../topics-eb548880.js';
import '../../index-579ca9d7.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../compareIds-2e50e905.js';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/message';
import '../../consts-fa6ab3c0.js';
import '../../resolvedReplyType-9d00a3db.js';
import '../../withSendbird.js';
import '../../Thread/context/types.js';
import '@sendbird/chat';
function SuggestedUserMentionItem(props) {
  var member = props.member,
    _props$isFocused = props.isFocused,
    isFocused = _props$isFocused === void 0 ? false : _props$isFocused,
    parentScrollRef = props.parentScrollRef,
    _onClick = props.onClick,
    _onMouseOver = props.onMouseOver,
    _onMouseMove = props.onMouseMove,
    renderUserMentionItem = props.renderUserMentionItem;
  var scrollRef = useRef(null);
  var _useContext = useContext(LocalizationContext),
    _useContext$stringSet = _useContext.stringSet,
    stringSet = _useContext$stringSet === void 0 ? {} : _useContext$stringSet;
  useEffect(function () {
    if (isFocused && (parentScrollRef === null || parentScrollRef === void 0 ? void 0 : parentScrollRef.current) != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) != null && (parentScrollRef.current.scrollTop >= scrollRef.current.offsetTop || parentScrollRef.current.scrollTop + parentScrollRef.current.clientHeight <= scrollRef.current.offsetTop)) {
      scrollRef.current.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }, [isFocused]);
  var customMentionItem = useMemo(function () {
    if (renderUserMentionItem) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "sendbird-mention-suggest-list__user-item",
        onClick: function onClick(event) {
          return _onClick === null || _onClick === void 0 ? void 0 : _onClick({
            event: event,
            member: member,
            itemRef: scrollRef
          });
        },
        onMouseOver: function onMouseOver(event) {
          return _onMouseOver === null || _onMouseOver === void 0 ? void 0 : _onMouseOver({
            event: event,
            member: member,
            itemRef: scrollRef
          });
        },
        onMouseMove: function onMouseMove(event) {
          return _onMouseMove === null || _onMouseMove === void 0 ? void 0 : _onMouseMove({
            event: event,
            member: member,
            itemRef: scrollRef
          });
        },
        key: (member === null || member === void 0 ? void 0 : member.userId) || uuidv4(),
        ref: scrollRef
      }, renderUserMentionItem({
        user: member
      }));
    }
  }, [renderUserMentionItem]);
  if (customMentionItem) {
    return customMentionItem;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-mention-suggest-list__user-item ".concat(isFocused ? 'focused' : ''),
    onClick: function onClick(event) {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick({
        event: event,
        member: member,
        itemRef: scrollRef
      });
    },
    onMouseOver: function onMouseOver(event) {
      return _onMouseOver === null || _onMouseOver === void 0 ? void 0 : _onMouseOver({
        event: event,
        member: member,
        itemRef: scrollRef
      });
    },
    onMouseMove: function onMouseMove(event) {
      return _onMouseMove === null || _onMouseMove === void 0 ? void 0 : _onMouseMove({
        event: event,
        member: member,
        itemRef: scrollRef
      });
    },
    key: (member === null || member === void 0 ? void 0 : member.userId) || uuidv4(),
    ref: scrollRef
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: "sendbird-mention-suggest-list__user-item__avatar",
    src: member === null || member === void 0 ? void 0 : member.profileUrl,
    alt: "user-profile",
    width: "24px",
    height: "24px"
  }), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-mention-suggest-list__user-item__nickname",
    type: LabelTypography.SUBTITLE_2,
    color: member !== null && member !== void 0 && member.nickname ? LabelColors.ONBACKGROUND_1 : LabelColors.ONBACKGROUND_3
  }, (member === null || member === void 0 ? void 0 : member.nickname) || (stringSet === null || stringSet === void 0 ? void 0 : stringSet.MENTION_NAME__NO_NAME)), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-mention-suggest-list__user-item__user-id",
    type: LabelTypography.SUBTITLE_2,
    color: LabelColors.ONBACKGROUND_2
  }, member === null || member === void 0 ? void 0 : member.userId));
}
var DEBOUNCING_TIME = 300;
function SuggestedMentionList(props) {
  var _useChannelContext, _useThreadContext, _stores$sdkStore, _stores$sdkStore$sdk, _stores$sdkStore$sdk$;
  var className = props.className,
    _props$targetNickname = props.targetNickname,
    targetNickname = _props$targetNickname === void 0 ? '' : _props$targetNickname,
    onUserItemClick = props.onUserItemClick,
    onFocusItemChange = props.onFocusItemChange,
    onFetchUsers = props.onFetchUsers,
    renderUserMentionItem = props.renderUserMentionItem,
    inputEvent = props.inputEvent,
    _props$ableAddMention = props.ableAddMention,
    ableAddMention = _props$ableAddMention === void 0 ? true : _props$ableAddMention,
    _props$maxMentionCoun = props.maxMentionCount,
    maxMentionCount = _props$maxMentionCoun === void 0 ? MAX_USER_MENTION_COUNT : _props$maxMentionCoun,
    _props$maxSuggestionC = props.maxSuggestionCount,
    maxSuggestionCount = _props$maxSuggestionC === void 0 ? MAX_USER_SUGGESTION_COUNT : _props$maxSuggestionC;
  var currentGroupChannel = useChannelContext === null || useChannelContext === void 0 ? void 0 : (_useChannelContext = useChannelContext()) === null || _useChannelContext === void 0 ? void 0 : _useChannelContext.currentGroupChannel;
  var currentChannel = useThreadContext === null || useThreadContext === void 0 ? void 0 : (_useThreadContext = useThreadContext()) === null || _useThreadContext === void 0 ? void 0 : _useThreadContext.currentChannel;
  var channelInstance = currentGroupChannel || currentChannel;
  var _useSendbirdStateCont = useSendbirdStateContext(),
    config = _useSendbirdStateCont.config,
    stores = _useSendbirdStateCont.stores;
  var logger = config.logger;
  var currentUserId = (stores === null || stores === void 0 ? void 0 : (_stores$sdkStore = stores.sdkStore) === null || _stores$sdkStore === void 0 ? void 0 : (_stores$sdkStore$sdk = _stores$sdkStore.sdk) === null || _stores$sdkStore$sdk === void 0 ? void 0 : (_stores$sdkStore$sdk$ = _stores$sdkStore$sdk.currentUser) === null || _stores$sdkStore$sdk$ === void 0 ? void 0 : _stores$sdkStore$sdk$.userId) || '';
  var scrollRef = useRef(null);
  var _useContext2 = useContext(LocalizationContext),
    stringSet = _useContext2.stringSet;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchString = _useState4[0],
    setSearchString = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    lastSearchString = _useState6[0],
    setLastSearchString = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentUser = _useState8[0],
    setCurrentUser = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    currentMemberList = _useState0[0],
    setCurrentMemberList = _useState0[1];
  useEffect(function () {
    clearTimeout(timer);
    setTimer(setTimeout(function () {
      setSearchString(targetNickname);
    }, DEBOUNCING_TIME));
  }, [targetNickname]);
  useEffect(function () {
    if ((inputEvent === null || inputEvent === void 0 ? void 0 : inputEvent.key) === MessageInputKeys.Enter) {
      if (currentMemberList.length > 0) {
        onUserItemClick(currentUser);
      }
    }
    if ((inputEvent === null || inputEvent === void 0 ? void 0 : inputEvent.key) === MessageInputKeys.ArrowUp) {
      var currentUserIndex = currentMemberList.findIndex(function (member) {
        return (member === null || member === void 0 ? void 0 : member.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
      });
      if (0 < currentUserIndex) {
        setCurrentUser(currentMemberList[currentUserIndex - 1]);
        onFocusItemChange(currentMemberList[currentUserIndex - 1]);
      }
    }
    if ((inputEvent === null || inputEvent === void 0 ? void 0 : inputEvent.key) === MessageInputKeys.ArrowDown) {
      var _currentUserIndex = currentMemberList.findIndex(function (member) {
        return (member === null || member === void 0 ? void 0 : member.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
      });
      if (_currentUserIndex < currentMemberList.length - 1) {
        setCurrentUser(currentMemberList[_currentUserIndex + 1]);
        onFocusItemChange(currentMemberList[_currentUserIndex + 1]);
      }
    }
  }, [inputEvent]);

  /* Fetch member list */
  useEffect(function () {
    if (!(channelInstance !== null && channelInstance !== void 0 && channelInstance.createMemberListQuery)) {
      logger.warning('SuggestedMentionList: Creating member list query failed');
      return;
    }
    if (lastSearchString && searchString.indexOf(lastSearchString) === 0 && currentMemberList.length === 0) {
      // Don't need to request query again
      return;
    }
    var query = channelInstance === null || channelInstance === void 0 ? void 0 : channelInstance.createMemberListQuery({
      limit: maxSuggestionCount + 1,
      // because current user could be included
      nicknameStartsWithFilter: searchString.slice(USER_MENTION_TEMP_CHAR.length)
    });
    // Add member list query for customization
    query.next().then(function (memberList) {
      var suggestingMembers = memberList.filter(function (member) {
        return currentUserId !== (member === null || member === void 0 ? void 0 : member.userId);
      }).slice(0, maxSuggestionCount);
      if (suggestingMembers.length < 1) {
        logger.info('SuggestedMentionList: Fetched member list is empty');
      } else {
        logger.info('SuggestedMentionList: Fetching member list succeeded', {
          memberListQuery: query,
          memberList: suggestingMembers
        });
        setCurrentUser(suggestingMembers[0]);
      }
      setLastSearchString(searchString);
      onFetchUsers(suggestingMembers);
      setCurrentMemberList(suggestingMembers);
    }).catch(function (error) {
      if (error) {
        logger.error('SuggestedMentionList: Fetching member list failed', error);
      }
    });
  }, [channelInstance === null || channelInstance === void 0 ? void 0 : channelInstance.url, searchString]);
  if (!ableAddMention && currentMemberList.length === 0) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-mention-suggest-list ".concat(className),
    key: "sendbird-mention-suggest-list",
    ref: scrollRef
  }, ableAddMention && (currentMemberList === null || currentMemberList === void 0 ? void 0 : currentMemberList.map(function (member) {
    return /*#__PURE__*/React__default.createElement(SuggestedUserMentionItem, {
      key: (member === null || member === void 0 ? void 0 : member.userId) || uuidv4(),
      member: member,
      isFocused: (member === null || member === void 0 ? void 0 : member.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId),
      parentScrollRef: scrollRef,
      onClick: function onClick(_ref) {
        var member = _ref.member;
        onUserItemClick(member);
      },
      onMouseOver: function onMouseOver(_ref2) {
        var member = _ref2.member;
        setCurrentUser(member);
      },
      renderUserMentionItem: renderUserMentionItem
    });
  })), !ableAddMention && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-mention-suggest-list__notice-item"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    className: "sendbird-mention-suggest-list__notice-item__icon",
    type: IconTypes.INFO,
    fillColor: IconColors.ON_BACKGROUND_2,
    width: "20px",
    height: "20px"
  }), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-mention-suggest-list__notice-item__text",
    type: LabelTypography.SUBTITLE_2,
    color: LabelColors.ONBACKGROUND_2
  }, stringSet.MENTION_COUNT__OVER_LIMIT.replace('%d', maxMentionCount))));
}
export { SuggestedMentionList as default };